import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import * as utils from '../../../utils';
import {
    useGetConfigQuery,
    useGetMeQuery,
    useGetProjectQuery,
} from '../../../store';

export const TagMenuItem = (props) => {
    const { icon, text, saveHandler, tagName, configId, opsDisable } = props;

    const [, setCpqData] = utils.cpqDataState.useStateContext();

    const { projectId } = useParams();
    const { data: project } = useGetProjectQuery(projectId);
    const { data: currentUser } = useGetMeQuery();
    const { data: config } = useGetConfigQuery();
    const { extQuoteInfo } = project;

    const projectInfo = useMemo(() => {
        let currency = '';
        if (
            extQuoteInfo &&
            extQuoteInfo.currency &&
            extQuoteInfo.currency !== ''
        ) {
            currency = extQuoteInfo.currency;
        } else {
            currency = project?.country;
            currency ??= currentUser?.settings?.find((x) => x.key === 'currency')?.value;
            currency ??= 'USD';
        }
        return {
            name: project?.name,
            currency: currency,
            customerNumber: project?.customerNumber,
        };
    }, [project, extQuoteInfo, currentUser]);

    return (
        <button
            className={classNames(
                'swegon-like-button white w-full text-left flex-row',
                opsDisable ? 'text-gray-30' : 'text-black-90 cursor-pointer',
            )}
            onClick={() =>
                opsDisable
                    ? null
                    : setCpqData({
                          showModal: true,
                          configuratorId: configId,
                          onSubmit: saveHandler,
                          projectInfo: projectInfo,
                          projectSiteInfoJson: project.siteInfoConfiguratorJson,
                          onConfiguratorLoaded: (conf) => {
                              switch (configId) {
                                  case config?.configurators.CTB:
                                      conf.setFields({
                                          'fEquipment Tag': tagName,
                                      });
                                      break;
                                  default:
                                      conf.setFields({ fTag: tagName });
                                      break;
                              }
                          },
                      })
            }
        >
            <div className="w-10">{icon}</div>
            <div>{text}</div>
        </button>
    );
};
